/** Local token budget for DPDP policy generation (AI-style usage tracking). */

export const DEFAULT_POLICY_TOKEN_QUOTA = 50000;
const QUOTA_KEY = "onedpdp_policy_token_quota";
const USED_KEY_PREFIX = "onedpdp_policy_tokens_used_";

/** Rough token estimate: ~4 characters per token for English prose. */
export function estimateTextTokens(text) {
  const s = String(text || "").trim();
  if (!s) return 0;
  return Math.ceil(s.length / 4);
}

/** Tokens to generate one policy (content + prompt overhead). */
export function estimatePolicyTokens(policy) {
  const parts = [
    policy.title,
    policy.subtitle,
    policy.actRef,
    ...(policy.clauses || []).flatMap((c) => [c.title, c.content]),
  ];
  const contentTokens = estimateTextTokens(parts.join(" "));
  const promptOverhead = 150;
  return contentTokens + promptOverhead;
}

export function estimatePoliciesTokens(policies = []) {
  return policies.reduce((sum, p) => sum + estimatePolicyTokens(p), 0);
}

export function formatTokenCount(n) {
  return Number(n || 0).toLocaleString("en-IN");
}

export function getTokenQuota() {
  try {
    const stored = localStorage.getItem(QUOTA_KEY);
    const parsed = Number(stored);
    return parsed > 0 ? parsed : DEFAULT_POLICY_TOKEN_QUOTA;
  } catch {
    return DEFAULT_POLICY_TOKEN_QUOTA;
  }
}

export function getTokensUsed(userKey = "default") {
  try {
    return Number(localStorage.getItem(`${USED_KEY_PREFIX}${userKey}`)) || 0;
  } catch {
    return 0;
  }
}

export function getTokensRemaining(userKey = "default") {
  return Math.max(0, getTokenQuota() - getTokensUsed(userKey));
}

export function canAffordTokens(userKey, amount) {
  return getTokensRemaining(userKey) >= amount;
}

export function deductTokens(userKey, amount) {
  const next = getTokensUsed(userKey) + Math.max(0, Number(amount) || 0);
  try {
    localStorage.setItem(`${USED_KEY_PREFIX}${userKey}`, String(next));
  } catch {
    // ignore storage errors
  }
  return getTokensRemaining(userKey);
}
